import { Box, Grid, Paper } from "@mui/material"
import { Entite, entitesList, Preuve } from "./DataTypes"
import { useState } from "react"
import BaseTextField from "../core/components/base/BaseTextField";
import PreuveSelector from "./PreuveSelector";
import {  isEmpty, isNil } from "lodash";
import EntiteDetail from "./EntiteDetail";



const PhasmophobiaTracker = () => {

    let [nbPreuves, setNbPreuves] = useState(3);
    let [preuvesTrouvees, setPreuvesTrouvees] = useState<Array<Preuve>>([]);
    let [preuvesRejected, setPreuvesRejected] = useState<Array<Preuve>>([]);
    let [santeMentalFirstAttaque, setSanteMentalFirstAttaque] = useState<number |null>(null)
    let [ghostselected, setGhostSelected] = useState<Entite | null>(null)
    let [excludedGhosts, setExcludedGhosts] = useState<Array<Entite>>([])
    let [sidePreuves, setSidePreuves] = useState<Array<string>>([])
    let [excludeSidePreuves, setExcludeSidePreuves] = useState<Array<string>>([])
    

    const changePreuveTrouvees = (preuve: Preuve) => {
            if(preuvesTrouvees.some(x => x === preuve))
            {
                setPreuvesTrouvees([...preuvesTrouvees.filter(x => x !== preuve)])
                return;
            }

            if(preuvesTrouvees.length > nbPreuves)
                return;

            if(preuvesTrouvees.length === nbPreuves && preuvesTrouvees.every(x => x !== "Orbe") && preuve !== "Orbe")
                return;

            setPreuvesTrouvees([...preuvesTrouvees, preuve]);
            if(preuvesRejected.some(x => x === preuve))
                setPreuvesRejected([...preuvesRejected.filter(x => x !== preuve)])
        } 

    const changePreuveRejected = (preuve: Preuve) => {
        if(preuvesRejected.some(x => x === preuve))
            {
                setPreuvesRejected([...preuvesRejected.filter(x => x !== preuve)])
                return;
            }

            setPreuvesRejected([...preuvesRejected, preuve]);
            if(preuvesTrouvees.some(x => x === preuve))
                setPreuvesTrouvees([...preuvesTrouvees.filter(x => x !== preuve)])
    }

    const addRemovePreuve = (preuve: Preuve, find: boolean = true) =>{

       
        if(find)
            changePreuveTrouvees(preuve)
        else
            changePreuveRejected(preuve)
         
            
    }


    console.log(sidePreuves, excludeSidePreuves)


    return <Box display={"flex"} flexDirection={"column"} width={"100%"} marginTop={"10px"}>
        <Grid container>
            <Grid item xs={6} sm={1} container>
                <BaseTextField sx={{maxWidth: "150px", marginRight: "5px"}} label="Nb Preuves" value={nbPreuves} onChange={(v) => setNbPreuves(Number(v.currentTarget.value))}/>
            </Grid>
            <Grid item xs={6} sm={1} container>
                <BaseTextField sx={{width: "150px"}} label="Sante Mentale 1ere attaque" value={santeMentalFirstAttaque} onChange={(v) => setSanteMentalFirstAttaque(Number(v.currentTarget.value))}/>
            </Grid>
            <Grid item xs={0} sm={10} />
            <Grid item container xs={12} sm={4} display={"flex"}>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"Temperature"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"Dots"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"EMF"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"Ecriture"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"Orbe"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"SpiritBox"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
                <PreuveSelector addRemovePreuve={addRemovePreuve} name={"UV"} preuvesTrouvees={preuvesTrouvees} preuvesRejected={preuvesRejected}/>
            </Grid>
            <Grid item container xs={6} sm={4} display={"flex"} justifyContent={"space-around"}>
                <Grid xs={12} textAlign={"center"}>Vitesse (pas de joueur en vue)</Grid>
                <Box 
                    sx={{color: sidePreuves.some(x => x === "LowSpeedNoHunt") ? "green" : excludeSidePreuves.some(x => x === "LowSpeedNoHunt") ? "red" : ""}}
                    onContextMenu={(ev) => {
                        ev.preventDefault();

                        setSidePreuves([...sidePreuves.filter(x => x !== "LowSpeedNoHunt")])

                        if(excludeSidePreuves.some(x => x === "LowSpeedNoHunt")){
                            setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "LowSpeedNoHunt")])
                        }
                        else{
                            setExcludeSidePreuves([...excludeSidePreuves, "LowSpeedNoHunt"])
                        }
                    }}
                    onClick={() => {

                        setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "LowSpeedNoHunt")])

                        if(sidePreuves.some(x => x === "LowSpeedNoHunt"))
                            setSidePreuves([...sidePreuves.filter(x => x !== "LowSpeedNoHunt")])
                        else
                            setSidePreuves([...sidePreuves, "LowSpeedNoHunt"])
                }}>Lente </Box>
                <Box 
                 sx={{color: sidePreuves.some(x => x === "NormalSpeedNoHunt") ? "green" : excludeSidePreuves.some(x => x === "NormalSpeedNoHunt") ? "red" : ""}}
                 onContextMenu={(ev) => {
                     ev.preventDefault();

                    setSidePreuves([...sidePreuves.filter(x => x !== "NormalSpeedNoHunt")])
                     

                     if(excludeSidePreuves.some(x => x === "NormalSpeedNoHunt")){
                         setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "NormalSpeedNoHunt")])
                     }
                     else{
                         setExcludeSidePreuves([...excludeSidePreuves, "NormalSpeedNoHunt"])
                     }
                 }}
                onClick={() => {
                    setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "NormalSpeedNoHunt")])

                    if(sidePreuves.some(x => x === "NormalSpeedNoHunt"))
                        setSidePreuves([...sidePreuves.filter(x => x !== "NormalSpeedNoHunt")])
                    else
                        setSidePreuves([...sidePreuves, "NormalSpeedNoHunt"])
                }}>Normal</Box>
                <Box 
                    sx={{color: sidePreuves.some(x => x === "FastSpeedNoHunt") ? "green" : excludeSidePreuves.some(x => x === "FastSpeedNoHunt") ? "red" : ""}}
                    onContextMenu={(ev) => {
                        ev.preventDefault();
   
                       setSidePreuves([...sidePreuves.filter(x => x !== "FastSpeedNoHunt")])
                        if(excludeSidePreuves.some(x => x === "FastSpeedNoHunt")){
                            setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "FastSpeedNoHunt")])
                        }
                        else{
                            setExcludeSidePreuves([...excludeSidePreuves, "FastSpeedNoHunt"])
                        }
                    }}
                    onClick={() => {
                        setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "FastSpeedNoHunt")])
                        if(sidePreuves.some(x => x === "FastSpeedNoHunt"))
                            setSidePreuves([...sidePreuves.filter(x => x !== "FastSpeedNoHunt")])
                        else
                            setSidePreuves([...sidePreuves, "FastSpeedNoHunt"])
                    }}>Rapide</Box>
            </Grid>
            <Grid item container xs={6} sm={4} display={"flex"} justifyContent={"space-around"}>
                <Grid xs={12} textAlign={"center"}>Accélération (joueur en vue)</Grid>
                <Box 
                    sx={{color: sidePreuves.some(x => x === "LowSpeedHunt") ? "green" : excludeSidePreuves.some(x => x === "LowSpeedHunt") ? "red" : ""}}
                    onContextMenu={(ev) => {
                        ev.preventDefault();

                        setSidePreuves([...sidePreuves.filter(x => x !== "LowSpeedHunt")])
                        
                        if(excludeSidePreuves.some(x => x === "LowSpeedHunt")){
                            setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "LowSpeedHunt")])
                        }
                        else{
                            setExcludeSidePreuves([...excludeSidePreuves, "LowSpeedHunt"])
                        }
                    }}
                    onClick={() => {

                        setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "LowSpeedHunt")])

                        if(sidePreuves.some(x => x === "LowSpeedHunt"))
                            setSidePreuves([...sidePreuves.filter(x => x !== "LowSpeedHunt")])
                        else
                            setSidePreuves([...sidePreuves, "LowSpeedHunt"])
                }}>Ralentissement</Box>
                <Box 
                 sx={{color: sidePreuves.some(x => x === "ConstantSpeedHunt") ? "green" : excludeSidePreuves.some(x => x === "ConstantSpeedHunt") ? "red" : ""}}
                 onContextMenu={(ev) => {
                     ev.preventDefault();

                    setSidePreuves([...sidePreuves.filter(x => x !== "ConstantSpeedHunt")])
                     

                     if(excludeSidePreuves.some(x => x === "ConstantSpeedHunt")){
                         setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "ConstantSpeedHunt")])
                     }
                     else{
                         setExcludeSidePreuves([...excludeSidePreuves, "ConstantSpeedHunt"])
                     }
                 }}
                onClick={() => {
                    setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "ConstantSpeedHunt")])

                    if(sidePreuves.some(x => x === "ConstantSpeedHunt"))
                        setSidePreuves([...sidePreuves.filter(x => x !== "ConstantSpeedHunt")])
                    else
                        setSidePreuves([...sidePreuves, "ConstantSpeedHunt"])
                }}>Constant</Box>
                <Box 
                    sx={{color: sidePreuves.some(x => x === "NormalSpeedHunt") ? "green" : excludeSidePreuves.some(x => x === "NormalSpeedHunt") ? "red" : ""}}
                    onContextMenu={(ev) => {
                        ev.preventDefault();
   
                       setSidePreuves([...sidePreuves.filter(x => x !== "NormalSpeedHunt")])
                        if(excludeSidePreuves.some(x => x === "NormalSpeedHunt")){
                            setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "NormalSpeedHunt")])
                        }
                        else{
                            setExcludeSidePreuves([...excludeSidePreuves, "NormalSpeedHunt"])
                        }
                    }}
                    onClick={() => {
                        setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "NormalSpeedHunt")])
                        if(sidePreuves.some(x => x === "NormalSpeedHunt"))
                            setSidePreuves([...sidePreuves.filter(x => x !== "NormalSpeedHunt")])
                        else
                            setSidePreuves([...sidePreuves, "NormalSpeedHunt"])
                    }}>Normal</Box>
                       <Box 
                    sx={{color: sidePreuves.some(x => x === "ExtremeFastSpeedHunt") ? "green" : excludeSidePreuves.some(x => x === "ExtremeFastSpeedHunt") ? "red" : ""}}
                    onContextMenu={(ev) => {
                        ev.preventDefault();
   
                       setSidePreuves([...sidePreuves.filter(x => x !== "ExtremeFastSpeedHunt")])
                        if(excludeSidePreuves.some(x => x === "ExtremeFastSpeedHunt")){
                            setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "ExtremeFastSpeedHunt")])
                        }
                        else{
                            setExcludeSidePreuves([...excludeSidePreuves, "ExtremeFastSpeedHunt"])
                        }
                    }}
                    onClick={() => {
                        setExcludeSidePreuves([...excludeSidePreuves.filter(x => x !== "ExtremeFastSpeedHunt")])
                        if(sidePreuves.some(x => x === "ExtremeFastSpeedHunt"))
                            setSidePreuves([...sidePreuves.filter(x => x !== "ExtremeFastSpeedHunt")])
                        else
                            setSidePreuves([...sidePreuves, "ExtremeFastSpeedHunt"])
                    }}>Extreme</Box>
            </Grid>
        </Grid>
       
        <Box display={"flex"} width={"100%"}>
        <Box display={"flex"} width={"500px"} flexWrap={"wrap"}>
            {entitesList.map(e => {

                let available = preuvesTrouvees.every(x => [...e.preuves].some(y => y === x));

                if(preuvesTrouvees.every(x => (x !== e.preuveObligatoire && !isNil(e.preuveObligatoire))) && preuvesTrouvees.length === nbPreuves)
                    available = false;

                if(preuvesTrouvees.length > nbPreuves && e.preuveObligatoire === "Orbe" )
                    available = true;

                if(preuvesTrouvees.length > nbPreuves && e.name !== "Mimic")
                    available = false

                if(preuvesRejected.some(x => e.preuveObligatoire === x || e.preuves.some(y => y === x)))
                    available = false;
                
                if(excludedGhosts.some(x => x.name === e.name))
                    available = false

                let availableAttack = true;
                if(!isNil(santeMentalFirstAttaque))
                {
                    if(e.santeMentalPouvoir < santeMentalFirstAttaque && e.santeMental < santeMentalFirstAttaque)
                        availableAttack = false;
                        
                }

                let sidePreuvesCheck = isNil(sidePreuves) ? true : sidePreuves.every(x => e.sidePreuves?.some(y => y === x)) && (isEmpty(excludeSidePreuves) || !excludeSidePreuves.some(x => e.sidePreuves?.some(y => y === x)))

                //console.log(e.name, excludeSidePreuves, sidePreuves.every(x => e.sidePreuves?.some(y => y === x)), !excludeSidePreuves.some(x => e.sidePreuves?.some(y => y === x)), isEmpty(excludeSidePreuves))


                let ghostAvailable = available && availableAttack && sidePreuvesCheck;

                return <Box margin={"5px"} width={"95px"} textAlign={"center"}
                    sx={{textDecoration: ghostAvailable ? "" : "line-through", opacity: ghostAvailable ? 1 : 0.2}}
                    onClick={() => setGhostSelected(e)}
                    onContextMenu={(event) => {
                        event.preventDefault(); 
                        if(!excludedGhosts.some(x => x.name === e.name))
                            setExcludedGhosts([...excludedGhosts, e])
                        else
                            setExcludedGhosts([...excludedGhosts.filter(x => x.name !== e.name)])
                    }}
                >
                    {e.name}
                </Box>
            })}
        </Box>
        <Box component={Paper}>
            <EntiteDetail ghost={ghostselected} />
        </Box>
        </Box>
    </Box>
}

export default PhasmophobiaTracker